import { Icon, Button } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, Pressable } from 'native-base';
import React from 'react';

interface DetailsButtonProps {
  onPress?: () => void;
  isDisabled: boolean;
}

export const DetailsButton: React.FC<DetailsButtonProps> = (props) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const downloadIconColor = props.isDisabled ? 'neutral.light' : 'brand.tertiary.principal';
  const icon = <Icon name="ChevronRight" size="xs" color={Color[downloadIconColor]} />;

  if (isMobile) {
    return (
      <Box h={Spacing['inline.xxs']} w="full" alignItems="flex-end">
        <Button
          p={0}
          rightIcon={icon}
          _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}
          variant="textLink"
          {...props}>
          Detalhes
        </Button>
      </Box>
    );
  }

  return (
    <Pressable w="30px" {...props}>
      {icon}
    </Pressable>
  );
};
